// ------------------------------------------------------------------------------
// name: useExecuter - 包装 post 提交意图的 service，代管 loading 等状态，统一结构代码
// author: mudas
// created: 2025/4/23
// ------------------------------------------------------------------------------

import { useDelayState } from 'common/hooks';
import { isSuccessCode } from 'common/service';

export type Service<TData, TParams extends any[]> = (...args: TParams) => Promise<ExtendAxioResponse<TData>>;

/**
 * @param service
 * @param options
 * @deprecated 不再推荐使用，请使用 useSafeMutation 替代
 * @see common/hooks/useSafeMutation.ts
 */
export const useExecuter = <TData, TParams extends any[]>(
  service: Service<TData, TParams>,
  options?: { loadingDelay: number },
) => {
  const [loading, setLoading, resetDelay] = useDelayState<boolean>(false, options?.loadingDelay);

  const execute = (...params: TParams) => {
    return new Promise(async (resolve, reject) => {
      resetDelay();
      setLoading(true);

      try {
        const res = await service(...params);

        if (!isSuccessCode(res?.code)) throw new Error(res.message || res.msg);
        resolve(res.data);
      } catch (error) {
        reject(error);
      } finally {
        setLoading(false);
      }
    });
  };

  return { execute, loading };
};
